// extracted by mini-css-extract-plugin
module.exports = {"clientStats":"_2wzPXii","playersCount":"_1EX6dJX","tournamentsCount":"_13CdUwV","statsNumber":"_8Ys5PdB"};